document.addEventListener("DOMContentLoaded", function () {
    "use strict";

    // TOGGLE VISIBILITY LOGIC
    const toggle = document.getElementById("zwssgr-widget_tabbing_enabled");
    const widgetSelector = document.getElementById("zwssgr-widget-selector");

    if (toggle && widgetSelector) {
        const updateVisibility = () => {
            if (toggle.checked) {
                toggle.value = 1;
                widgetSelector.classList.remove("hidden");
                widgetSelector.classList.add("visible");
            } else {
                toggle.value = 0;
                widgetSelector.classList.remove("visible");
                widgetSelector.classList.add("hidden");
            }
        };

        updateVisibility();
        toggle.addEventListener("change", updateVisibility);
    }

    // CUSTOM MULTI-SELECT LOGIC
    const selectField = document.getElementById("zwssgr_widget_select_field");
    const searchInput = document.getElementById("zwssgr-widget-search-input");
    const tagContainer = document.getElementById("zwssgr-selected-tags");
    const dropdown = document.getElementById("zwssgr-widget-dropdown");

    if (selectField && searchInput && tagContainer && dropdown) {
        const options = Array.from(selectField.options);

        function renderTags() {
            tagContainer.innerHTML = "";

            options.forEach(opt => {
                if (opt.selected) {
                    const tag = document.createElement("div");
                    tag.className = "zwssgr-widget-selected-tag zwssgr-custom-selected-tag";
                    tag.textContent = opt.text;

                    const remove = document.createElement("span");
                    remove.className = "zwssgr-remove-tag";
                    remove.textContent = "×";
                    remove.onclick = () => {
                        opt.selected = false;
                        renderTags();
                        renderDropdown(searchInput.value);
                    };

                    tag.appendChild(remove);
                    tagContainer.appendChild(tag);
                }
            });
        }

        function renderDropdown(filter = "") {
            dropdown.innerHTML = "";

            const filtered = options.filter(opt =>
                !opt.selected && opt.text.toLowerCase().includes(filter.toLowerCase())
            );

            if (filtered.length === 0) {
                dropdown.style.display = "none";
                return;
            }

            filtered.forEach(opt => {
                const li = document.createElement("li");
                li.textContent = opt.text;
                li.onclick = () => {
                    opt.selected = true;
                    renderTags();
                    searchInput.value = "";
                    renderDropdown();
                };
                dropdown.appendChild(li);
            });

            dropdown.style.display = "block";
        }

        searchInput.addEventListener("input", function () {
            renderDropdown(this.value);
        });

        searchInput.addEventListener("focus", function () {
            renderDropdown(this.value);
        });

        document.addEventListener("click", function (e) {
            if (!e.target.closest(".zwssgr-widget-multiselect-wrapper")) {
                dropdown.style.display = "none";
            }
        });

        // Initial render
        renderTags();
    }
});
